import apiClient from '@/plugins/axios'

export default {
  getColaboradores(filter) {
    return apiClient.post('colaborador/index', filter)
  },

  getColaborador(id) {
    return apiClient.get(`colaborador/${id}`)
  },

  getCpfCnpj(cpfcnpj) {
    return apiClient.get(`colaborador/getcpfcnpj/${cpfcnpj}`)
  },

  postColaborador(colaborador) {
    return apiClient.post(`colaborador`, { colaborador })

  },

  putColaborador(id, colaborador) {
    return apiClient.put(`colaborador/${id}`, { colaborador })

  },

  deleteColaborador(id) {
    return apiClient.delete(`colaborador/${id}`)
  },

  getDropDown() {
    return apiClient.get(`colaborador/dropdown`)
  },

  getPagination(url) {
    return apiClient.post(url)
  }

}


// WEBPACK FOOTER //
// ./src/views/Colaborador/_services/ColaboradorService.js